import React, { useEffect, useState } from "react";
import {
  MapPin,
  CreditCard,
  User,
  ChevronRight,
  Info,
  Plus,
  Minus,
  Clock,
} from "lucide-react";

import { useAuth } from "../context/AuthContext";

const AccountSection: React.FC<{
  isLoggedIn: boolean;
  setIsModalOpen: () => void;
  activeTab: "login" | "signup";
  setActiveTab: React.Dispatch<React.SetStateAction<"login" | "signup"> >;
    isLineStyle?: boolean;
}> = ({ isLoggedIn, setIsModalOpen, activeTab, setActiveTab, isLineStyle}) => {
  const { user } = useAuth();

  if (isLoggedIn) {
    return (
      <div className={`bg-white rounded-lg  mb-0 ${isLineStyle ? "p-[1px] pt-[2px] pb-4" : " p-5 pt-4"}`}>
       <div className="w-full bg-white py-3 px-3 border-[1px] border-black/10 rounded-[15px] overflow-hidden dm-checkout-section">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
                  <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] flex-shrink-0 rounded-full flex items-center justify-center text-2xl sm:text-3xl font-bold select-none" style={{ backgroundColor: 'var(--bw-black)', color: 'var(--bw-white)' }}>
                    {(user?.name || 'U').charAt(0).toUpperCase()}
                  </div>
            <div>
              <h3 className="font-semibold text-[19px] text-black mb-0">Account</h3>
              <p className="text-[15px] text-black/70 mb-[2px]">{user?.email}</p>
              <p className="text-[14px] text-black/70 mb-[2px]">{user?.phonenumber}</p>
            </div>
          </div>
          {/* <ChevronRight className="w-5 h-5 text-gray-400" /> */}
        </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 mb-6 `}>
      <div className="flex items-center gap-4 mb-6">
        <User className="w-5 h-5 text-gray-700" />
        <div>
          <h3 className="font-semibold text-gray-900">Account</h3>
          <p className="text-sm text-gray-600">
            To place your order now, log in to your existing account or sign up.
          </p>
        </div>
      </div>

      <div className="flex gap-4">
        <button
          onClick={() => {
            setActiveTab("login");
            setIsModalOpen();
          }}
          className={`flex-1 py-3 px-0 sm:px-6 border-2 rounded-lg font-medium transition-colors ${
            activeTab === "login"
              ? "border-black/30 text-black"
              : "border-gray-300 text-gray-700 hover:border-gray-400"
          }`}
        >
          <div className="text-xs text-gray-500 mb-1">Have an account?</div>
          LOG IN
        </button>

        <button
          onClick={() => {
            setActiveTab("signup");
            setIsModalOpen();
          }}
          className={`flex-1 py-3 px-0 sm:px-6 border-2 rounded-lg font-medium transition-colors ${
            activeTab === "signup"
              ? "bg-black text-white border-black/30"
              : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
          }`}
        >
          <div className="text-xs mb-1 opacity-90">New User?</div>
          SIGN UP
        </button>
      </div>
    </div>
  );
};

export default AccountSection;
